import { environment } from '../environments/environment';
import { lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ClientWebCore } from './cores/ClientWebCore';
import { ClientAccountWebStore } from '@root/web/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToastProvider } from '@libs/react/ui';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
    },
  },
});

const AdminCoresWebCore = lazy(() => import('./cores/AdminCoresWebCore'));
const BizWebCore = lazy(() => import('./cores/BizWebCore'));
const AccountSessionWebCore = lazy(
  () => import('./cores/AccountSessionWebCore'),
);
const AccountAuthWebModule = lazy(
  () => import('./modules/AccountAuthWebModule'),
);
const UserAccountSessionCore = lazy(
  () => import('./cores/UserAccountSessionCore'),
);
const MinaWebCore = lazy(() => import('./cores/MinaWebCore'));
const AccountWebCore = lazy(() => import('./cores/AccountWebCore'));

export function App() {
  ClientAccountWebStore.init({
    backendURL: environment.backend.root,
    signInURL: environment.client.authURL,
  });
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Navigate replace to="/mina" />} index></Route>

            {environment.routes.mina && (
              <Route element={<AccountWebCore />} path="/account/*" />
            )}
            {environment.routes.auth && (
              <Route element={<AccountAuthWebModule />} path="/auth/*" />
            )}
            {environment.routes.adminCores && (
              <Route element={<AdminCoresWebCore />} path="/admin/*" />
            )}
            {environment.routes.biz && (
              <Route element={<BizWebCore />} path="/biz/*" />
            )}
            {environment.routes.mina && (
              <Route element={<MinaWebCore />} path="/mina/*" />
            )}
            {environment.routes.session && (
              <Route
                element={<AccountSessionWebCore />}
                path="/account/session"
              />
            )}
            {environment.routes.session && (
              <Route element={<AccountSessionWebCore />} path="/session/*" />
            )}
            {environment.routes.session && (
              <Route
                element={<UserAccountSessionCore />}
                path="user/account-session/*"
              />
            )}
            {environment.routes.client && (
              <Route element={<ClientWebCore />} path="/client/*" />
            )}
          </Routes>
        </BrowserRouter>
      </ToastProvider>
    </QueryClientProvider>
  );
}

export default App;
